import React, { useEffect, useRef } from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { useLang } from '../../context/LangContext';
import Button from '../ui/Button';
import Ticker from '../ui/Ticker';
import '../../styles/Hero.css';

export default function Hero() {
  const { t } = useLang();
  const floatRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let frame: number;
    let start: number | null = null;
    const animate = (ts: number) => {
      if (!start) start = ts;
      const elapsed = (ts - start) / 1000;
      if (floatRef.current) {
        floatRef.current.style.transform = `translateY(${Math.sin(elapsed * 0.6) * 14}px)`;
      }
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <section className="hero" id="acasa">
      <div className="hero__bg">
        <div className="hero__circle hero__circle--1" />
        <div className="hero__circle hero__circle--2" />
        <div className="hero__dots" />
      </div>

      <div className="container hero__inner">
        {}
        <div className="hero__content animate-fadeUp">
          <div className="hero__eyebrow">
            <span className="hero__dot" />
            {t.hero.eyebrow}
          </div>
          <h1 className="hero__title">
            {t.hero.titleLine1}{' '}
            <span className="hero__title--accent">{t.hero.titleAccent}</span>{' '}
            {t.hero.titleLine2}
          </h1>
          <p className="hero__lead">{t.hero.lead}</p>
          <div className="hero__trust">
            {t.hero.trust.map((item: string) => (
              <span key={item} className="hero__trust-item">
                <CheckCircle2 size={15} />{item}
              </span>
            ))}
          </div>
          <div className="hero__actions">
            <Button as="a" href="#contact" variant="primary" size="lg" iconRight={<ArrowRight />}>
              {t.hero.ctaPrimary}
            </Button>
            <Button as="a" href="#servicii" variant="ghost" size="lg">
              {t.hero.ctaSecondary}
            </Button>
          </div>
        </div>

        {}
        <div className="hero__visual animate-slideLeft" style={{ padding: 0 }}>
          <div className="hero__card" ref={floatRef}>
            <div className="hero__stats-grid">
              {t.stats.map((s: { value: string; label: string }) => (
                <div key={s.label} className="hero__stat">
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Ticker items={t.hero.ticker} />
    </section>
  );
}
